<template lang="pug">
.sidebar(:data-color='backgroundColor')
  //.logo
    a.simple-text.logo-mini(href='/')
      .logo-image
        //#statusLogo(:class="!subsActive || !onLine || error ? 'warn' : ''" )
          div.logo()
          div.status(v-on:click="getStatus" style="border-radius: 24px; cursor:pointer;width:36px;height:36px;z-index: 2;position:absolute;margin:5px -7px;background: transparent;" )
          geno-logo(:class="spinner ? 'rotateLoading' : ''" style="width: 36px; height: 36px; margin: 4px -7px; position: absolute;")
    a.simple-text.logo-normal(href='/')
      | {{title}}
    .navbar-minimize
      button#minimizeSidebar.btn.btn-simple.btn-icon.btn-neutral.btn-round(@click='minimizeSidebar')
        i.now-ui-icons.text_align-center.visible-on-sidebar-regular
        i.now-ui-icons.design_bullet-list-67.visible-on-sidebar-mini
  .sidebar-wrapper(ref='sidebarScrollArea')
    slot
    ul.nav
      slot(name='links')
        sidebar-item(v-for='(link, index) in sidebarLinks', :key='link.name + index', :link='link')
          sidebar-item(v-for='(subLink, index) in link.children', :key='subLink.name + index', :link='subLink')
</template>
<script>
export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'ITILITY Health'
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: value => {
        let acceptedValues = [
          '',
          'blue',
          'azure',
          'green',
          'orange',
          'red',
          'purple',
          'black'
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'img/icon-vue.png'
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        //this.$sidebar.toggleMinimize();
      }
    }
  },
      mounted() {
        //this.$sidebar.toggleMinimize();
        },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>

#app .sidebar .nav, .off-canvas-sidebar .nav {
    margin-top: 43px;
    }
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
